import React, { useState, useEffect } from "react";
import $ from "jquery";

import "./DisclaimerModal.scss";

// Function that checks if the local storage is available
function localStorageAvailable() {
  var storage;
  try {
      storage = window['localStorage'];
      var x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
  }
  catch(e) {
    console.log(e);
      return e instanceof DOMException && (
          // everything except Firefox
          e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
          // acknowledge QuotaExceededError only if there's something already stored
          (storage && storage.length !== 0);
  }
}

function DisclaimerModal() {
  const [hideDisclaimer, setHideDisclaimer] = useState(localStorageAvailable() && window.localStorage.getItem("hideDisclaimer") === "true");
  useEffect(() => {
    var hideDisclaimerFromLocalStorage = localStorageAvailable() && window.localStorage.getItem("hideDisclaimer") === "true";
    if (!hideDisclaimerFromLocalStorage) {
      $("#disclaimer").modal("show");
    }
  }, []);

  const onHideDisclaimerChange = (event) => {
    if (localStorageAvailable()) {
      window.localStorage.setItem("hideDisclaimer", event.target.checked);
      setHideDisclaimer(event.target.checked);
    }
  };

  return (
    <div
      className="modal fade"
      id="disclaimer"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="disclaimerTitle"
      area-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="disclaimerTitle">
              DISCLAIMER
            </h5>
          </div>
          <div className="modal-body">
            <p className="text-justify">
              The prognostic tool, also known as prognostic nomogram, located on the UCLA website is for general health
              information only. The tool should not be used as a substitute for medical advice or treatment decision.
            </p>
            <p className="text-justify">
              UCLA makes no warranties, nor express or implied representations whatsoever, regarding the accuracy,
              completeness, timeliness, or usefulness of any information contained or referenced in the LuPSMA
              prognostic tool. UCLA does not assume any risk whatsoever for your use of the LuPSMA prognostic tool or
              the information contained herein.
            </p>
            <p className="text-justify">
              Use of the LuPSMA prognostic tool does not create an express or implied physician-patient relationship.
              UCLA does not endorse or claim validity for the prognostic tool found on the UCLA website. The activities
              and products of UCLA and its developers and agents (collectively UCLA) are not endorsed by our past,
              present, or future employers. UCLA does not record any information provided by the user and does not
              contact users of the prognostic tool.
            </p>
            <p className="text-justify">
              In using the LuPSMA prognostic tool, you agree that neither UCLA nor any other party is or will be liable
              or otherwise responsible for any decision made or any action taken or any action not taken due to your use
              of any information presented in the prognostic tool.
            </p>
          </div>
          <div className="modal-footer">
            <p>
              <b>
                By clicking &ldquo;Continue&rdquo; below I accept all of the above terms or by any further use of this
                service.
              </b>
            </p>          
              {localStorageAvailable() && (
                <div className="form-check">
                <input
                className="form-check-input"
                type="checkbox"
                id="hideDisclaimerCheckbox"
                checked={hideDisclaimer}
                onChange={onHideDisclaimerChange}
              ></input>
              <label className="form-check-label" htmlFor="hideDisclaimerCheckbox">
                Do not show this message again
              </label>
              </div>
              )}
            <button type="button" className="btn btn-primary" data-dismiss="modal">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DisclaimerModal;
